import React, { useEffect, useRef, useState } from "react";

const stats = [
  { end: 85, prefix: "", suffix: "", label: "Sales Last 12 Months" },
  { end: 165, prefix: "", suffix: "+", label: "Total Sales" },
  { static: "$25K\u2013$2.5M", label: "Price Range" },
  { end: 725, prefix: "$", suffix: "K", label: "Average Price" },
];

const StatItem = ({ stat, start }) => {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (stat.static || !start) return;
    let raf;
    const duration = 1600;
    const t0 = performance.now();
    const tick = (now) => {
      const p = Math.min(1, (now - t0) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(Math.round(eased * stat.end));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [start, stat]);

  return (
    <div className="bg-[#f3f1ec] flex flex-col items-center justify-center text-center py-10 md:py-12 px-4 min-h-[150px] md:min-h-[180px]">
      <div className={`font-serif-display text-[#1a1a1a] leading-none mb-3 ${stat.static ? "text-2xl md:text-4xl" : "text-4xl md:text-5xl"}`}>
        {stat.static ? stat.static : `${stat.prefix}${val}${stat.suffix}`}
      </div>
      <div className="text-neutral-500 text-[10px] md:text-[11px] tracking-luxe uppercase">{stat.label}</div>
    </div>
  );
};

const StatsCounter = () => {
  const ref = useRef(null);
  const [start, setStart] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setStart(true); obs.disconnect(); } },
      { threshold: 0.3 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} className="bg-[#f3f1ec] py-16 md:py-24">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-black/10 border border-black/10 rounded-sm overflow-hidden">
          {stats.map((s, i) => (
            <StatItem key={i} stat={s} start={start} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsCounter;
